(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Service-Areas"] && !Shopify.designMode) return;
  try {
    
(function(){
  function levenshtein(a, b){
    if (a === b) return 0;
    var al = a.length, bl = b.length;
    if (al === 0) return bl;
    if (bl === 0) return al;
    var prev = new Array(bl + 1);
    var curr = new Array(bl + 1);
    for (var j = 0; j <= bl; j++) prev[j] = j;
    for (var i = 1; i <= al; i++){
      curr[0] = i;
      for (var k = 1; k <= bl; k++){
        var cost = a.charAt(i - 1) === b.charAt(k - 1) ? 0 : 1;
        curr[k] = Math.min(curr[k - 1] + 1, prev[k] + 1, prev[k - 1] + cost);
      }
      var tmp = prev; prev = curr; curr = tmp;
    }
    return prev[bl];
  }

  function fuzzyTolerance(len){
    if (len <= 4) return 1;
    if (len <= 8) return 2;
    return 3;
  }

  // Returns true if query fuzzy-matches any word (or the whole string) of `name`
  function fuzzyMatch(query, name){
    if (!query) return false;
    if (name.indexOf(query) !== -1) return true;
    var tolerance = fuzzyTolerance(query.length);
    var words = name.split(/\s+/);
    for (var i = 0; i < words.length; i++){
      var w = words[i];
      if (!w) continue;
      if (levenshtein(query, w) <= tolerance) return true;
      if (w.length > query.length){
        for (var s = 0; s <= w.length - query.length; s++){
          var windowStr = w.substr(s, query.length);
          if (levenshtein(query, windowStr) <= Math.max(1, tolerance - 1)) return true;
        }
      }
    }
    return false;
  }

  function debounce(fn, wait){
    var t;
    return function(){
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function(){ fn.apply(ctx, args); }, wait);
    };
  }

  function initAhasAreas(root){
    if (!root || root.dataset.ahasInit) return;
    root.dataset.ahasInit = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('.ahas-card'));
    var searchInput = root.querySelector('[data-ahas-search]');
    var resultCount = root.querySelector('[data-ahas-result-count]');
    var emptyState = root.querySelector('[data-ahas-empty]');
    var mobileGate = root.querySelector('[data-ahas-mobile-gate]');
    var revealWrap = root.querySelector('[data-ahas-reveal]');
    var gateLabelEl = mobileGate ? mobileGate.querySelector('[data-ahas-mobile-gate-label]') : null;
    var gateLabelCollapsed = gateLabelEl ? gateLabelEl.textContent : '';
    var gateLabelExpanded = root.getAttribute('data-mobile-gate-label-expanded') || gateLabelCollapsed;

    function isSearching(){
      return !!(searchInput && searchInput.value.trim().length > 0);
    }

    function isMobileViewport(){
      return window.matchMedia('(max-width: 639px)').matches;
    }

    function setGateRevealed(revealed){
      if (!mobileGate || !revealWrap) return;
      revealWrap.classList.toggle('is-revealed', revealed);
      mobileGate.setAttribute('aria-expanded', String(revealed));
      if (gateLabelEl) gateLabelEl.textContent = revealed ? gateLabelExpanded : gateLabelCollapsed;
      if (revealed) requestAnimationFrame(layoutAll);
    }

    function rowsForViewport(){
      var isMobile = isMobileViewport();
      var desktopRows = parseInt(root.getAttribute('data-rows-desktop'), 10) || 3;
      var mobileRows = parseInt(root.getAttribute('data-rows-mobile'), 10) || 2;
      return isMobile ? mobileRows : desktopRows;
    }

    // Matches the .ahas-areas__grid column breakpoints (1 / 2 / 3 columns),
    // used to figure out which cards share a visual row.
    function columnsForViewport(){
      if (window.matchMedia('(min-width: 1024px)').matches) return 3;
      if (window.matchMedia('(min-width: 640px)').matches) return 2;
      return 1;
    }

    function toggleLabel(isAr, remaining, expanded){
      if (expanded) return isAr ? 'عرض أقل' : 'Show less';
      return isAr ? ('+' + remaining + ' منطقة أخرى') : ('+' + remaining + ' more areas');
    }

    // Measures how many chips fit within `rows` rows at the card's current
    // width. Runs with transitions forcibly disabled so re-measuring never
    // visibly "pops" the chips open before collapsing them back — only an
    // explicit button press should ever animate anything.
    function measureCutoff(wrap, chips, rows){
      wrap.classList.add('is-measuring');
      chips.forEach(function(c){ c.classList.remove('is-extra-hidden'); });
      void wrap.offsetHeight; // force reflow so offsetTop reflects the unwrapped layout

      var lastTop = chips[0].offsetTop;
      var rowIndex = 0;
      var cutoff = chips.length;
      for (var i = 0; i < chips.length; i++){
        var top = chips[i].offsetTop;
        if (top - lastTop > 4){
          rowIndex++;
          lastTop = top;
          if (rowIndex >= rows){ cutoff = i; break; }
        }
      }
      return cutoff;
    }

    // Instantly (no animation) applies a card's own collapsed/expanded state.
    // Used for initial load, font-load, and resize — never touches siblings.
    function applyCardLayout(card, rows){
      var wrap = card.querySelector('[data-chips]');
      var toggleRow = card.querySelector('[data-toggle-row]');
      var toggle = card.querySelector('[data-ahas-toggle]');
      if (!wrap || !toggle) return;

      var chips = Array.prototype.slice.call(wrap.querySelectorAll('.ahas-chip'));
      if (!chips.length){ if (toggleRow) toggleRow.hidden = true; return; }

      // Mobile uses the header accordion instead of the per-row "show
      // more" — every chip is shown in the DOM and visibility is handled
      // purely by the CSS accordion on .ahas-card__body, so skip the row
      // measurement entirely here.
      if (isMobileViewport()){
        if (toggleRow) toggleRow.hidden = true;
        chips.forEach(function(c){
          c.classList.remove('is-extra-hidden');
          c.style.transitionDelay = '0ms';
        });
        return;
      }

      var cutoff = measureCutoff(wrap, chips, rows);
      card.dataset.cutoff = cutoff;

      var remaining = chips.length - cutoff;
      var needsToggle = remaining > 0;
      var isAr = root.getAttribute('dir') === 'rtl';
      var expanded = toggle.getAttribute('data-expanded') === 'true';

      if (toggleRow) toggleRow.hidden = !needsToggle;
      toggle.setAttribute('data-remaining', remaining);

      var textEl = toggle.querySelector('.ahas-toggle-btn__text');
      if (textEl) textEl.textContent = toggleLabel(isAr, remaining, expanded && needsToggle);

      chips.forEach(function(c, i){
        c.style.transitionDelay = '0ms';
        var shouldHide = !(expanded && needsToggle) && i >= cutoff;
        c.classList.toggle('is-extra-hidden', shouldHide);
      });

      void wrap.offsetHeight; // commit the instant state before re-enabling transitions
      wrap.classList.remove('is-measuring');
    }

    function layoutAll(){
      if (isSearching()) return; // don't disturb the live search view
      var rows = rowsForViewport();
      cards.forEach(function(card){ applyCardLayout(card, rows); });
    }

    // Animates a single card open/closed. This is the ONLY place transitions
    // are allowed to run — everything else (load, resize, font-load, search)
    // applies state instantly via applyCardLayout().
    function animateCard(card, expand){
      var wrap = card.querySelector('[data-chips]');
      var toggle = card.querySelector('[data-ahas-toggle]');
      if (!wrap || !toggle) return;
      var chips = Array.prototype.slice.call(wrap.querySelectorAll('.ahas-chip'));
      var cutoff = parseInt(card.dataset.cutoff, 10);
      if (isNaN(cutoff)) cutoff = chips.length;
      var remaining = chips.length - cutoff;
      var isAr = root.getAttribute('dir') === 'rtl';

      chips.forEach(function(c, i){
        if (i < cutoff) return;
        c.style.transitionDelay = expand ? (((i - cutoff) * 25) + 'ms') : '0ms';
        c.classList.toggle('is-extra-hidden', !expand);
      });

      toggle.setAttribute('data-expanded', String(expand));
      toggle.setAttribute('aria-expanded', String(expand));
      var textEl = toggle.querySelector('.ahas-toggle-btn__text');
      if (textEl) textEl.textContent = toggleLabel(isAr, remaining, expand);
    }

    // Everything below is deferred until the section is actually about to
    // scroll into view (see the IntersectionObserver near the bottom of this
    // function) — it sits at the very bottom of the page, so none of this
    // work should compete with more important content for the initial load.
    var activated = false;
    function activate(){
      if (activated) return;
      activated = true;

      // Cursor-tracked spotlight per card
      cards.forEach(function(card){
        card.addEventListener('mousemove', function(e){
          var r = card.getBoundingClientRect();
          card.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
          card.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
        });
      });

      // Mobile gate: tapping it reveals (or re-hides) the whole coverage
      // grid via the CSS grid-rows accordion on .ahas-areas__reveal.
      if (mobileGate){
        mobileGate.addEventListener('click', function(){
          var revealed = mobileGate.getAttribute('aria-expanded') === 'true';
          setGateRevealed(!revealed);
        });
      }

      // Expand/collapse toggle — fixed bottom-center position (see CSS).
      // On desktop/tablet, pressing it expands or collapses every OTHER card
      // sharing its grid row too (so a row never ends up lopsided), and on
      // collapse it brings the row back into view if it scrolled past the top.
      root.querySelectorAll('[data-ahas-toggle]').forEach(function(toggle){
        toggle.addEventListener('click', function(){
          var card = toggle.closest('.ahas-card');
          var cardIndex = cards.indexOf(card);
          var wasExpanded = toggle.getAttribute('data-expanded') === 'true';
          var expand = !wasExpanded;

          var columns = columnsForViewport();
          var rowStart = Math.floor(cardIndex / columns) * columns;
          var rowCards = cards.slice(rowStart, rowStart + columns);

          rowCards.forEach(function(rowCard){
            var rowToggleRow = rowCard.querySelector('[data-toggle-row]');
            // only animate row-mates that actually have a toggle to begin with
            if (rowToggleRow && !rowToggleRow.hidden) animateCard(rowCard, expand);
          });

          if (wasExpanded){
            requestAnimationFrame(function(){
              var rect = card.getBoundingClientRect();
              if (rect.top < 0) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
          }
        });
      });

      // Mobile accordion: tapping the header (icon + name + arrow) opens or
      // closes the whole chip list for that card. Only active below 640px —
      // the row-based "show more" button handles desktop/tablet instead.
      root.querySelectorAll('.ahas-card__head').forEach(function(head){
        head.addEventListener('click', function(){
          if (!isMobileViewport()) return;
          var card = head.closest('.ahas-card');
          var btn = head.querySelector('[data-ahas-head-toggle]');
          if (!btn) return; // no areas to expand
          var expanded = card.classList.toggle('is-mobile-expanded');
          btn.setAttribute('aria-expanded', String(expanded));
        });
      });

      // Live search (exact substring first, falls back to fuzzy/misspelling match)
      if (searchInput){
        searchInput.addEventListener('input', function(){
          var q = this.value.trim().toLowerCase();
          var totalMatches = 0;
          var mobile = isMobileViewport();

          // Typing a query is itself a request to see results — auto-reveal
          // the mobile gate rather than making the user tap it first.
          if (mobile && q.length > 0) setGateRevealed(true);

          cards.forEach(function(card){
            var chips = card.querySelectorAll('.ahas-chip');
            var toggleRow = card.querySelector('[data-toggle-row]');
            var cardMatches = 0;

            chips.forEach(function(chip){
              var name = chip.getAttribute('data-name');
              var isMatch = q.length > 0 && fuzzyMatch(q, name);
              chip.classList.toggle('is-match', isMatch);

              if (q.length === 0) return;

              if (isMatch){
                cardMatches++;
                // bring matched areas to the top of the card (via .is-match's
                // CSS order) and reveal them even if they were collapsed
                chip.classList.remove('is-dim', 'is-extra-hidden');
                chip.style.transitionDelay = '0ms';
              } else {
                chip.classList.add('is-dim');
              }
            });

            if (toggleRow) toggleRow.style.display = q.length > 0 ? 'none' : '';
            card.classList.toggle('is-hidden', q.length > 0 && cardMatches === 0);

            // On mobile, auto-expand the accordion for cards with matches so
            // the highlighted areas are actually visible while searching.
            if (mobile){
              var shouldExpand = q.length > 0 && cardMatches > 0;
              card.classList.toggle('is-mobile-expanded', shouldExpand);
              var headBtn = card.querySelector('[data-ahas-head-toggle]');
              if (headBtn) headBtn.setAttribute('aria-expanded', String(shouldExpand));
            }

            totalMatches += cardMatches;
          });

          if (q.length === 0){
            cards.forEach(function(card){
              card.querySelectorAll('.ahas-chip').forEach(function(c){ c.classList.remove('is-dim'); });
              if (mobile){
                card.classList.remove('is-mobile-expanded');
                var headBtn = card.querySelector('[data-ahas-head-toggle]');
                if (headBtn) headBtn.setAttribute('aria-expanded', 'false');
              }
            });
            layoutAll(); // restore each card's own collapsed/expanded row state
            if (resultCount) resultCount.textContent = '';
            if (emptyState) emptyState.hidden = true;
          } else if (totalMatches === 0){
            if (resultCount) resultCount.textContent = '';
            if (emptyState){
              emptyState.hidden = false;
              var term = emptyState.querySelector('[data-term]');
              if (!term){
                emptyState.innerHTML = emptyState.innerHTML.replace('{term}', '<b data-term>' + this.value.trim() + '</b>');
              } else {
                term.textContent = this.value.trim();
              }
            }
          } else {
            if (emptyState) emptyState.hidden = true;
            if (resultCount) resultCount.innerHTML = '<b>' + totalMatches + '</b>';
          }
        });
      }

      // Clone the shared floating WhatsApp / Book Now buttons into this
      // section's CTA row — same pattern as the Final CTA section, so all
      // button styling/number/copy stays single-sourced from the floating row.
      function mountAhasButtons(){
        var target = document.getElementById('ahasButtonsTarget-{{ section.id }}');
        if (!target || target.dataset.mounted) return;

        var waSource = document.getElementById('floatingWaBtn');
        var bookSource = document.getElementById('floatingBookNowBtn');
        if (!waSource && !bookSource) return; // floating row not in DOM yet, retry later

        target.dataset.mounted = 'true';

        if (waSource){
          var waClone = waSource.cloneNode(true);
          waClone.removeAttribute('id');
          target.appendChild(waClone);

          new MutationObserver(function(mutations){
            mutations.forEach(function(m){
              if (m.attributeName === 'href'){
                waClone.setAttribute('href', waSource.getAttribute('href'));
              }
            });
          }).observe(waSource, { attributes: true, attributeFilter: ['href'] });
        }

        if (bookSource){
          var bookClone = bookSource.cloneNode(true);
          bookClone.removeAttribute('id');
          target.appendChild(bookClone);
        }
      }
      mountAhasButtons();
      window.addEventListener('load', mountAhasButtons);

      // Run immediately, then again once fonts/images have settled — text
      // metrics before web fonts finish loading can under/over-count how many
      // chips actually fit per row, which is what causes a card to show more
      // than the intended row count until something else forces a re-layout.
      layoutAll();
      requestAnimationFrame(layoutAll);
      if (document.fonts && document.fonts.ready){
        document.fonts.ready.then(layoutAll);
      }
      window.addEventListener('load', layoutAll);
      window.addEventListener('resize', debounce(function(){
        // A resize can cross the mobile breakpoint — re-sync the gate's
        // expanded state with the (now possibly irrelevant) CSS override.
        layoutAll();
      }, 180));
    }

    // The section sits at the very bottom of the page, so treat it as low
    // priority: don't measure/animate/mount anything until the user is
    // actually about to scroll to it. A generous rootMargin means it's fully
    // ready (rows collapsed, buttons mounted) well before it's on screen, so
    // nothing pops in late.
    if ('IntersectionObserver' in window){
      var activateObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting){
            activate();
            activateObserver.disconnect();
          }
        });
      }, { rootMargin: '600px 0px 600px 0px' });
      activateObserver.observe(root);
    } else {
      activate(); // no IntersectionObserver support — fall back to running immediately
    }
    function animateCount(el, target, suffix){
      var start = performance.now();
      var duration = 1100;
      function tick(now){
        var p = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(eased * target) + (suffix || '');
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    var totalAreas = parseInt(root.getAttribute('data-total-areas'), 10) || 0;
    var statsAnimated = false;

    function runStats(){
      if (statsAnimated) return;
      statsAnimated = true;
      root.querySelectorAll('.ahas-stat__num').forEach(function(el){
        if (el.hasAttribute('data-count')) animateCount(el, parseInt(el.getAttribute('data-count'), 10));
        else if (el.hasAttribute('data-count-areas')) animateCount(el, totalAreas);
        else if (el.hasAttribute('data-static')) el.textContent = el.getAttribute('data-static');
      });
    }

    // Scroll reveal
    var revealEls = root.querySelectorAll('.ahas-reveal');
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting){
            var el = entry.target;
            var idx = cards.indexOf(el);
            var delay = idx > -1 ? (idx % 6) * 60 : 0;
            setTimeout(function(){ el.classList.add('is-visible'); }, delay);
            if (el.querySelector && el.querySelector('.ahas-stat__num')) runStats();
            io.unobserve(el);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function(el){ io.observe(el); });
    } else {
      revealEls.forEach(function(el){ el.classList.add('is-visible'); });
      runStats();
    }
  }

  function initAll(){
    document.querySelectorAll('.ahas-areas').forEach(initAhasAreas);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector ? e.target.querySelector('.ahas-areas') : null;
    if (root) initAhasAreas(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function(){
  function easeInOut(t){ return t < 0.5 ? 2*t*t : -1+(4-2*t)*t; }

  function animateTo(setP, from, to, duration, onDone){
    var start = null;
    function step(ts){
      if(!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      setP(from + (to - from) * easeInOut(progress));
      if(progress < 1){ requestAnimationFrame(step); }
      else { if(onDone) onDone(); }
    }
    requestAnimationFrame(step);
  }

  function initWrap(wrap){
    if (wrap.dataset.baInit) return;
    wrap.dataset.baInit = 'true';

    var stage  = wrap.querySelector('[data-ba-stage]');
    var before = wrap.querySelector('[data-ba-before]');
    var divEl  = wrap.querySelector('[data-ba-div]');
    var knob   = wrap.querySelector('[data-ba-knob]');
    var swept  = false;

    function setP(p){
      p = Math.max(1, Math.min(99, p));
      before.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
      divEl.style.left   = p + '%';
      divEl.style.height = stage.offsetHeight + 'px';
      knob.style.left    = p + '%';
    }

    // Start at 75% (showing mostly before), sweep to 25% (mostly after) once
    // in view, then settle at 50%.
    setP(75);

    var sweepObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting && !swept){
          swept = true;
          sweepObserver.disconnect();
          setTimeout(function(){
            animateTo(setP, 75, 25, 1100, function(){
              setTimeout(function(){
                animateTo(setP, 25, 50, 600, null);
              }, 300);
            });
          }, 400);
        }
      });
    }, { threshold: 0.4 });
    sweepObserver.observe(wrap);

    // Manual drag — overrides the animation. window-level listeners are
    // only attached while an actual drag is happening, not for the whole
    // page's lifetime.
    var dragging = false;

    function go(x){
      var r = stage.getBoundingClientRect();
      setP((x - r.left) / r.width * 100);
    }

    function onMove(e){ if (dragging) go(e.clientX); }
    function onTouchMove(e){ if (dragging) go(e.touches[0].clientX); }
    function endDrag(){
      if (!dragging) return;
      dragging = false;
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', endDrag);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', endDrag);
    }
    function startDrag(x){
      dragging = true;
      go(x);
      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', endDrag);
      window.addEventListener('touchmove', onTouchMove, { passive: true });
      window.addEventListener('touchend', endDrag);
    }

    stage.addEventListener('mousedown', function(e){ startDrag(e.clientX); e.preventDefault(); });
    stage.addEventListener('touchstart', function(e){ startDrag(e.touches[0].clientX); }, { passive: true });

    window.addEventListener('resize', function(){ setP(parseFloat(divEl.style.left)); });
  }

  function initSection(section){
    if (!section || section.dataset.baSectionInit) return;
    section.dataset.baSectionInit = 'true';

    var wraps = Array.prototype.slice.call(section.querySelectorAll('[data-ba-wrap]'));
    if (!wraps.length) return;

    function activate(){
      wraps.forEach(initWrap);
    }

    // Section sits low on the page — defer all listener/observer setup
    // until it's about to scroll into view instead of doing it at load.
    if ('IntersectionObserver' in window){
      var lowPriorityObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting){
            activate();
            lowPriorityObserver.disconnect();
          }
        });
      }, { rootMargin: '600px 0px 600px 0px' });
      lowPriorityObserver.observe(section);
    } else {
      activate();
    }
  }

  function initAll(){
    document.querySelectorAll('.ba-section').forEach(initSection);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector ? e.target.querySelector('.ba-section') : null;
    if (el) initSection(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initScroll() {
    var btns = document.querySelectorAll('.js-scroll-to-packages');

    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var target = document.getElementById('det-pkg-grid');
        if (!target) return;

        var offset = 800;
        var targetPosition =
          target.getBoundingClientRect().top +
          window.pageYOffset -
          offset;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      });
    });
  }

  // ── Delay-loaded hero video ──
  // The poster <img> (eager, fetchpriority=high, responsive srcset) is what
  // every visitor sees immediately and is the LCP element, on every device.
  // Once the page is idle, the real <source> is assigned and playback
  // starts; once it's actually rendering frames the poster crossfades out
  // via CSS. This still keeps the video off the critical rendering path —
  // it just no longer skips mobile.
  function maybeLoadVideo() {
    var wrap = document.querySelector('[data-video-wrap]');
    var video = wrap && wrap.querySelector('.onhow-video-js[data-video-src]');
    if (!video) return;

    // Respect data saver / very slow connections, where supported.
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var saveData = conn && (conn.saveData || /2g/.test(conn.effectiveType || ''));
    if (saveData) return;

    var src = video.getAttribute('data-video-src');
    if (!src) return;

    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);
    video.load();

    video.addEventListener('playing', function () {
      wrap.classList.add('is-video-ready');
    });

    video.play().catch(function () {
      // Autoplay blocked in this context — poster image remains visible.
    });
  }

  // Defer until after first paint / idle time so it never competes with
  // LCP/FCP.
  if ('requestIdleCallback' in window) {
    requestIdleCallback(maybeLoadVideo, { timeout: 2500 });
  } else {
    window.addEventListener('load', maybeLoadVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScroll);
  } else {
    initScroll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
